import type { TemperatureResult } from '@/services/types';
import { extractDayInTimezone } from '@/utils/date';

import type { BodyWoundsData, EnrichedBodyWoundsData } from './types';

/**
 * Joins each body-wounds day with the temperature of the same calendar day.
 *
 * The temperature endpoint sends `day` as a full timestamp (`2026-09-04T00:00:00.000Z`), while
 * the wound days are `YYYY-MM-DD`. The timestamp is read in UTC, the calendar day the column
 * holds. The legacy OptoGraphs mapper formatted it in the browser zone instead, which put every
 * temperature one day early west of UTC.
 */
export function enrichBodyWoundsDataWithTemperature(
    bodyWoundsData: BodyWoundsData,
    temperature: TemperatureResult[]
): EnrichedBodyWoundsData {
    const temperatures = temperature.map((row) => ({ ...row, day: toCalendarDay(row.day) }));

    return {
        ...bodyWoundsData,
        days: bodyWoundsData.days.map((day) => ({
            ...day,
            temperature:
                temperatures.find((temp) => temp.day === day.day)?.temperature ?? undefined,
        })),
    };
}

function toCalendarDay(day: string): string {
    return day.includes('T') ? extractDayInTimezone(day, 'UTC') : day;
}
